export default "__VITE_ASSET__4925c11d__"